// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_STROLLERS_HOMEPAGE = "Zp\u011bt na ko\u010d\u00e1rkopedii";
export const STROLLER_ADD_QUESTION = "Zeptej se v poradn\u011b";
export const STROLLER_AT_OFFICIAL_PAGE_OF_name = "ofici\u00e1ln\u00ed str\u00e1nce %(name)s";
export const STROLLER_DETAIL_ARTICLES_WITH_stroller = "\u010cl\u00e1nky s %(stroller)s";
export const STROLLER_DETAIL_DESCRIPTION = "Popis ko\u010d\u00e1rku";
export const STROLLER_DETAIL_LINKED_OBJECTS = "Poradny a diskuze";
export const STROLLER_DETAIL_MORE_ARTICLES_WITH_stroller = "Dal\u0161\u00ed \u010dl\u00e1nky s %(stroller)s";
export const STROLLER_DETAIL_SHOW_AVAILABLE_VARIANTS = "Zobrazit dostupn\u00e9 varianty";
export const STROLLER_FEATURES = "Parametry";
export const STROLLER_HAS_BEEN_DELETED = "Tenhle ko\u010d\u00e1rek byl smaz\u00e1n";
export const STROLLER_MORE_DESCRIPTION = "Zobraz cel\u00fd popis";
export const STROLLER_MORE_INFO_AT_link = "V\u00edce informac\u00ed na %(link)s";
export const STROLLERS_DETAILED_REVIEW = "Podrobn\u00e1 recenze";
export const STROLLERS_DETAIL_MORE_STROLLERS_OF_THIS_brand = "Dal\u0161\u00ed ko\u010d\u00e1rky %(brand)s";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
export const STROLLER_UNPREPARED_TAG = "P\u0159ipravujeme";
